import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

type KomboConnectLink = {
  link: string;
}

export function useCreateKomboConnectLink () {
  return useMutation<KomboConnectLink, GrapeAPIErrorType, { payrollProviderConfigId: string }>({
    mutationFn: async ({ payrollProviderConfigId }: { payrollProviderConfigId: string }) => {
      const response = await fetchWithHeaders(
        '/api/web/payroll/kombo/create_connect_link',
        {
          method: 'POST',
          body: JSON.stringify({ payroll_provider_config_id: payrollProviderConfigId }),
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }

      return response.json()
    },
  })
}
